export default "__VITE_ASSET__1fb764a0__"